import { useSyncExternalStore } from "react";

// Место в стопке звонков (.icall-stack у InboundCallHost) для свёрнутой плашки
// исходящего. Стопка на экране одна: в ней всплывашки входящих и свёрнутый
// входящий, и плашка исходящего встаёт туда же порталом — тогда их раскладывает
// одна вёрстка, и они не наезжают друг на друга ни в полной версии (справа
// сверху), ни на телефоне (под шапкой).
//
// Реестр на уровне модуля: хосты входящих и исходящих стоят в шелле рядом, а
// не один в другом.

let slot: HTMLElement | null = null;
const listeners = new Set<() => void>();

/** ref-колбэк контейнера в InboundCallHost. */
export function setCallStackSlot(el: HTMLElement | null) {
  if (slot === el) return;
  slot = el;
  listeners.forEach((l) => l());
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

/** Контейнер для плашки; null — стопки на экране нет. */
export function useCallStackSlot(): HTMLElement | null {
  return useSyncExternalStore(subscribe, () => slot, () => null);
}
